import React from "react";
import { Grid } from "@mui/material";
import CalcolaForm from "./CalcolaForm";
import GaranzieList from "./GaranzieList";

const StepCalcola = ({
  formData,
  errors,
  onInputChange,
  onPrivacyChange,
  onCalcolaClick,
  onReset,
}) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={6}>
        <CalcolaForm
          formData={formData}
          errors={errors}
          onInputChange={onInputChange}
          onPrivacyChange={onPrivacyChange}
          onCalcolaClick={onCalcolaClick}
          onReset={onReset}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <GaranzieList />
      </Grid>
    </Grid>
  );
};

export default StepCalcola;
